<app-dialog-header 
  [title]="'Gerenciador de Mídia'"
  [buttons]="dialogButtons"
  [maximizado]="false"
  [showTabs]="true"
  [tabs]="[{id: 0, label: 'Galeria'}, {id: 1, label: 'Upload'}]"
  [selectedTab]="selectedTab"
  (tabChange)="onTabChange($event)"
  (close)="fechar()">
</app-dialog-header>

<mat-dialog-content>
      <!-- Aba: Galeria -->
      <div class="tab-content" *ngIf="selectedTab === 0">
        <div class="galeria-wrapper">
          <div class="galeria-scroll">
            <div *ngIf="carregando" class="loading-container">
              <mat-spinner diameter="50"></mat-spinner>
              <p>Carregando imagens...</p>
            </div>

            <div *ngIf="!carregando && imagens.length === 0" class="empty-state">
              <mat-icon>image_not_supported</mat-icon>
              <p>Nenhuma imagem encontrada</p>
              <p class="hint">Faça upload de uma imagem na aba "Upload"</p>
            </div>

            <div class="galeria-grid">
              <div 
                *ngFor="let imagem of imagens" 
                class="imagem-card"
                [class.selecionada]="imagem.selecionada"
                (click)="selecionarImagem(imagem)">
                
                <div class="imagem-wrapper">
                  <img [src]="imagem.urlCompleta" [alt]="imagem.nomeArquivo" />

                  <div *ngIf="imagem.selecionada" class="check-icon">
                    <mat-icon>check_circle</mat-icon>
                  </div>
                </div>

                <div class="imagem-info">
                  <span class="nome-arquivo" [matTooltip]="imagem.nomeArquivo">
                    {{ imagem.nomeArquivo }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Botão Carregar Mais -->
            <div *ngIf="!carregando && temMais" class="carregar-mais-container">
              <button 
                mat-raised-button 
                color="primary"
                (click)="carregarMais()">
                <mat-icon>expand_more</mat-icon>
                Carregar Mais Imagens
              </button>
              <p class="info-carregadas">
                {{ imagens.length }} de {{ totalImagens }} imagens carregadas
              </p>
            </div>

            <!-- Mensagem quando todas foram carregadas -->
            <div *ngIf="!carregando && !temMais && imagens.length > 0" class="todas-carregadas">
              <mat-icon>check_circle</mat-icon>
              <p>Todas as {{ totalImagens }} imagens foram carregadas</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Aba: Upload -->
      <div class="tab-content" *ngIf="selectedTab === 1">
        <div class="upload-container">
          <div 
            class="dropzone"
            (drop)="onDrop($event)"
            (dragover)="onDragOver($event)">
            
            <div *ngIf="!imagemPreview" class="dropzone-content">
              <mat-icon>cloud_upload</mat-icon>
              <p>Arraste uma imagem aqui</p>
              <p class="hint">ou</p>
              <button mat-raised-button color="primary" (click)="fileInput.click()">
                Selecionar Arquivo
              </button>
              <input 
                #fileInput 
                type="file" 
                accept="image/*" 
                (change)="onFileSelected($event)"
                style="display: none;">
            </div>
            <div *ngIf="imagemPreview" class="preview-container">
              <img [src]="imagemPreview" alt="Preview" />
            </div>
          </div>

            <div *ngIf="!imagemPreview" class="upload-info">
                <mat-icon>info</mat-icon>
                <div>
                  <p><strong>Formatos aceitos:</strong> JPG, JPEG, PNG, GIF, BMP, WEBP, SVG</p>
                  <p><strong>Tamanho máximo:</strong> 1MB</p>
                </div>
            </div>

          <div *ngIf="imagemPreview" class="upload-actions">
            <button 
              mat-raised-button 
              color="primary" 
              (click)="uploadImagem()"
              [disabled]="uploadEmProgresso"
              class="btn-upload">
              <mat-icon *ngIf="!uploadEmProgresso">cloud_upload</mat-icon>
              <mat-spinner *ngIf="uploadEmProgresso" diameter="20"></mat-spinner>
              {{ uploadEmProgresso ? 'Enviando...' : 'Fazer Upload' }}
            </button>
            <button 
              mat-raised-button
              color="warn"
              (click)="arquivoSelecionado = null; imagemPreview = null"
              [disabled]="uploadEmProgresso">
              <mat-icon>delete</mat-icon>
              Remover
            </button>
          </div>
        </div>
      </div>
</mat-dialog-content>